import React from "react";

const Licensing = () => {
  return (
    <div className="flex-1 flex-col h-fit w-full  radius-10 back-white  align-left justify-start  pt-3 pb-2 pl-3 pr-3 g-2">
      <div className="w-full flex-col align-left justify-start g-1">
        <h3 className="t-16 color-grayColor poppins-medium weight-500">
          Licensing
        </h3>
        <hr color="#e5e5e5" className="w-full" />
      </div>
      <div className="flex-col flex-1 scroll-y align-left justify-start g-2 w-full">
        <div className="flex-col align-left justify-start g-1 w-full flex-1">
          <h4 className="t-14 weight-500 poppins color-grayColor">
         📜 End-User License Agreement (EULA):
          </h4>
          <div className="flex-col align-left justify-start g-1">
            <span className="t-12 poppins color-textColor">
              This agreement outlines the rights and restrictions granted to
              users of this platform.
            </span>

            <ul className="flex-col align-left justify-start w-fit g-05 pl-1" style={{listStyleType:"dice !important"}}>
              <li className="t-12 poppins color-textColor">Use of this software is licensed, not sold.</li>
              <li className="t-12 poppins color-textColor">The license is non-exclusive, non-transferable, and restricted to institutional or educational use only.</li>
              <li className="t-12 poppins color-textColor">Reverse engineering, reselling, or unauthorized duplication is prohibited.</li>
              <li className="t-12 poppins color-textColor">Breach of agreement may result in termination of access.</li>
              <li className="t-12 poppins color-textColor">Governed by Indian law.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Licensing;
